import { gql } from "@apollo/client";
import moment from "moment";

const GET_INFORME_ASISTENCIAL_PACIENTE = gql`
query GetInformeAsistencialPaciente ( $idEvaluacion: Int!) {
    informeAsistencialPaciente( idEvaluacion: $idEvaluacion ){
        idEvaluacion,
        idPaciente,
        apellido,
        nombre,
        sexo,
        fechaNacimiento,
        edad,
        tipoDocumento,
        numeroDocumento,
        planActual,
        planInicial,
        familiar,
        familiarTelefono,
        vinculo,
        informacionAdicional,
        cobertura,
        numeroAfiliado,
        fechaAlta,
        calle,
        cp,
        localidad,
        provincia,
        observaciones,
        telefonoUbicacion,
        profesionales {
            idProfesionalNavigation {
              nombre,
              apellido
            }
            idTipoProfesionalNavigation {
                descripcion
            }
        },
        documentos {
          documento,
          existe
        }
    }
}
`;
export default GET_INFORME_ASISTENCIAL_PACIENTE;

export const adaptInformeAsistencialPaciente = (informe) => {
  return {
    idEvaluacion: informe?.idEvaluacion,
    idPaciente: informe?.idPaciente,
    apellido: informe?.apellido,
    nombre: informe?.nombre,
    sexo: informe?.sexo,
    fechaNacimiento: moment(informe?.fechaNacimiento).format('DD/MM/YYYY'),
    edad: informe?.edad,
    tipoDocumento: informe?.tipoDocumento,
    numeroDocumento: informe?.numeroDocumento,
    planActual: informe?.planActual,
    planInicial: informe?.planInicial,
    familiar: informe?.familiar,
    familiarTelefono: informe?.familiarTelefono,
    vinculo: informe?.vinculo,
    informacionAdicional: informe?.informacionAdicional,
    cobertura: informe?.cobertura,
    numeroAfiliado: informe?.numeroAfiliado,
    calle: informe?.calle,
    cp: informe?.cp,
    localidad: informe?.localidad,
    provincia: informe?.provincia,
    observaciones: informe?.observaciones,
    telefonoUbicacion: informe?.telefonoUbicacion,
    fechaAlta: moment(informe?.fechaAlta).format('DD/MM/YYYY HH:mm:ss'),
    profesionales: informe?.profesionales?.map((x) => {
      const { idProfesionalNavigation, idTipoProfesionalNavigation, ...data } = x;
      return {
        ...data,
        profesional: idProfesionalNavigation?.apellido + ", " + idProfesionalNavigation?.nombre,
        tipo: idTipoProfesionalNavigation?.descripcion
      };
    }),
    documentos: informe?.documentos
  };
};